export enum BioSampleDeliveryLabReasonType {
  SELECTED = 'SELECTED',
  OTHER = 'OTHER',
}
